import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

type SearchParamProps = Record<string, string | number | undefined>

export const useInstantRouting = (filterKeys: string[]) => {
  const [searchParams] = useSearchParams()

  const filters = useMemo(() => {
    const newQueryParams: SearchParamProps = {}
    filterKeys.forEach((key) => {
      const value = searchParams.get(key)
      if (value !== null) {
        newQueryParams[key] =
          Number.isInteger(Number(value)) &&
          (value.charAt(0) !== '0' || value.length === 1)
            ? Number(value)
            : value
      }
    })
    return newQueryParams
  }, [searchParams, filterKeys])

  return filters
}
